import React from 'react';
import { Select, Button, chakra as C } from '@tapresearch/ui/components';
import * as S from '../CampaignSurveyResultQuestionItem.styled';
import useAsset from '../../hook/useAsset';

import { Question } from './shared/types';
const GraphToggle = C(S.Button);

export interface ActionPanelProps {
  question: Question;
  questions: Question[];
  isMultipleChoice: boolean;
  isRanking: boolean;
  isCrossTab: boolean;
  crossTabQuestionId: string;
  renderMode: string;
  contributionMode: string;
  showEmptyResults: boolean;
  setRenderMode: (mode: string) => void;
  setShowEmptyResults: (showEmptyResults: boolean) => void;
  setContributionMode: (mode: string) => void;
  setCrossTabQuestionId: (value: string) => void;
}

export function ActionPanel({
  question,
  questions,
  isMultipleChoice,
  isRanking,
  isCrossTab,
  setCrossTabQuestionId,
  crossTabQuestionId,
  renderMode,
  setRenderMode,
  contributionMode,
  setShowEmptyResults,
  setContributionMode,
  showEmptyResults,
}: ActionPanelProps) {
  const asset = useAsset();
  return (
    (isMultipleChoice || isRanking) && (
      <S.PanelAction>
        <S.PanelActionLeftContainer>
          <S.PanelActionIconContainer>
            <img src={asset.arrow_right_icon} />
          </S.PanelActionIconContainer>
          <Select
            boxShadow="sm"
            variant="outline"
            fontWeight="medium"
            value={crossTabQuestionId}
            onChange={(e) => setCrossTabQuestionId(e.target.value)}
          >
            <option value="">Choose comparison</option>
            {questions.map(
              (q) =>
                q.answer_type !== asset.constants.TAP_ANSWER_TYPE_FREE_TEXT &&
                q.answer_type !== asset.constants.TAP_ANSWER_TYPE_MESSAGE &&
                (!isRanking ||
                  (isRanking &&
                    q.answer_type !==
                      asset.constants.TAP_ANSWER_TYPE_RANKING)) &&
                q.id !== question.id && (
                  <option value={q.id} key={q.id}>
                    {q.name}
                  </option>
                )
            )}
          </Select>
        </S.PanelActionLeftContainer>
        <S.PanelActionRightContainer>
          <S.LabelContainer>
            <S.ButtonGroup>
              <GraphToggle
                bg={renderMode === 'graph' ? 'blue.500' : 'gray.300'}
                active={renderMode === 'graph'}
                onClick={() => setRenderMode('graph')}
              >
                <img src={asset.bar_chart_icon} />
              </GraphToggle>
              <GraphToggle
                bg={renderMode === 'table' ? 'blue.500' : 'gray.300'}
                active={renderMode === 'table'}
                onClick={() => setRenderMode('table')}
              >
                <img src={asset.table_icon} />
              </GraphToggle>
            </S.ButtonGroup>
            {(isCrossTab || isRanking) && (
              <S.ButtonGroup>
                <GraphToggle
                  bg={
                    contributionMode === 'percentage' ? 'blue.500' : 'gray.300'
                  }
                  active={contributionMode === 'percentage'}
                  onClick={() => setContributionMode('percentage')}
                >
                  <img src={asset.percentage_icon} />
                </GraphToggle>
                <GraphToggle
                  bg={contributionMode === 'number' ? 'blue.500' : 'gray.300'}
                  active={contributionMode === 'number'}
                  onClick={() => setContributionMode('number')}
                >
                  <img src={asset.hash_tag_icon} />
                </GraphToggle>
              </S.ButtonGroup>
            )}
            {isCrossTab && (
              <Button
                onClick={() => setShowEmptyResults(!showEmptyResults)}
                variant={showEmptyResults ? 'solid' : 'outline'}
                colorScheme="blue"
                size="sm"
                minW="120px"
              >
                {showEmptyResults ? 'Hide Empty' : 'Show Empty'}
              </Button>
            )}
          </S.LabelContainer>
        </S.PanelActionRightContainer>
      </S.PanelAction>
    )
  );
}
